import { getState, modifyState, incrementState } from '~src/state';
import { updateUndoRedoControls } from '~core';

export const addEditorHistoryEntry = () => {
  if (getState('pauseCanvasHistory', false) === true) {
    console.debug('Skipping Canvas History due to pause request');
    return;
  }

  const undoInProgress = getState('undoInProgress');
  const redoInProgress = getState('redoInProgress');
  const currentPageIndex = getState('currentPageIndex');
  const isChangingPage = getState('isChangingPage');
  const history = getState(`history[${currentPageIndex}]`, []);

  if (
    undoInProgress === false &&
    redoInProgress === false &&
    isChangingPage === false
  ) {
    const currentEditorState = JSON.stringify(window.canvas);
    history.push(currentEditorState);

    modifyState(`history[${currentPageIndex}]`, history);

    incrementState(`currentHistoryIndex[${currentPageIndex}]`);
    incrementState('totalChangesSinceLastSave');
  }

  updateUndoRedoControls();
};
